//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PartnerFooter from '@/components/common/footer/PartnerFooter'
import ElLink from '@/components/UI/el-link'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'Contacts',
  components: { PartnerFooter, ElLink },
  computed: {
    ...mapGetters({
      mainSettings: 'landings/mainSettings',
    }),
    ...mapState(['i18n']),
  },
  methods: {
    isRussianFranchise() {
      return this.$getTextMainSetting('isRussianFranchise')
    },
    getLogo() {
      if (this.isRussianFranchise()) {
        return require('~/assets/img/pages/new-logo-ru.png')
      }
      return require('~/assets/img/pages/new-logo-en.png')
    },
  },
}
